import domReady from 'domready';

let showScrolledLogo = () => {
    let navWrapper = document.querySelector(".nav-wrapper");
    let scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    let scrolled = scrollTop > 120 ? true : false;

    if(navWrapper) {
        window.addEventListener('scroll', function(e) {
            scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

            if (scrollTop > 119 && scrolled === false) {
                navWrapper.classList.add("scrolled");
                scrolled = true;
            } else if (scrollTop < 120) {
                navWrapper.classList.remove("scrolled");
                scrolled = false;
            }
        });
    }

    
}

let openCloseNav = () => {
    let navHeaderLink = document.querySelector(".open-nav");
    let navItems = document.querySelector(".nav-items");
    let navBG = document.querySelector(".navigation-top");

    if(navItems) {
        navHeaderLink.addEventListener('click', () => {
            navItems.classList.contains("hide") ? navItems.classList.remove("hide") : navItems.classList.add("hide");
        })
    
        navItems.addEventListener('mouseleave', (event) => {
            if(event.toElement && !event.toElement.classList.contains("navigation-top")) {
                navItems.classList.add("hide");
            }
        })

        navBG.addEventListener('click', (event) => {
            if(event.target.classList.contains("navigation-top") && !navItems.classList.contains('hide')) {
                navItems.classList.add("hide");
            }
        })
    }
}

domReady(() => {
    showScrolledLogo();
    openCloseNav();
});
